module.exports = __webpack_public_path__ + "static/media/tikka_masala_2_placeholder.7f393b71.jpg";